const GnsqRoute = [
  {
    path: '/gnsq',//全科医生服务
    component: () => import('./views/index')
  },
  {
    path: '/gnsq/pay',//全科医生服务支付
    component: () => import('./views/pay')
  },
  {
    path: '/gnsq/packages',//全科医生服务包列表
    component: () => import('./views/packages')
  }
]

export default GnsqRoute



// WEBPACK FOOTER //
// ./src/page/gnsq/gnsqRoute.js